import Button from "Components/Common/Button/Button";
import Card from "./Card";

interface ChecklistItem {
  label: string;
  status: string;
  icon?: string;
  sub?: string;
  action?: () => void;
  actionLabel?: string;
  buttonLabel?: string;
}

interface ChecklistProps {
  title: string;
  items: ChecklistItem[];
}

const Checklist = ({ title, items }: ChecklistProps) => {
  return (
    <Card title={title}>
      {items.map((item) => (
        <div className="checklistItem" key={item.label}>
          <div className={`ciStatus ${item.status}`}>{item.icon}</div>
          <div className="ciBody">
            <div className="ciLabel">{item.label}</div>
            <div className="ciSub">{item.sub}</div>
          </div>
          {item.action ? (
            <div className="ciAction">
              <Button
                type="button"
                className="btn primary sm"
                onClick={item.action}
                disabled={!!item.actionLabel}
              >
                {item.actionLabel ? (
                  <>
                    <span className="btn-spinner" /> {item.actionLabel}
                  </>
                ) : (
                  (item.buttonLabel ?? "Upload")
                )}
              </Button>
            </div>
          ) : null}
        </div>
      ))}
    </Card>
  );
};

export default Checklist;
